import React from 'react'

export const Spacer = ({ className }) => {
  return <div className={className}></div>
}
